<template>
    <b-row>
        <Sidebar/>
        <b-col md="10" offset-md="2">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2">Lotes</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group mr-2">
                        <b-button variant="outline-secondary" to="/lotes/nuevo">Nuevo</b-button>
                    </div>
                </div>
            </div>
            <p v-if="isLoading">Cargando...</p>
            <b-table v-else hover v-bind:items="lots" v-bind:fields="headers" outlined
                     head-variant="light">
                <template slot="id" slot-scope="data">
                    <b-link v-bind:to="'/lotes/' + data.item.id">{{data.item.id}}</b-link>
                </template>
                <template slot="actions" slot-scope="data">
                    <div class="btn-group">
                        <b-button variant="outline-secondary" size="sm" v-bind:to="'/lotes/' + data.item.id">Ver</b-button>
                        <b-button variant="outline-secondary" size="sm" v-bind:to="'/lotes/editar/' + data.item.id">Editar</b-button>
                    </div>
                </template>
            </b-table>
        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "Lots",
        data() {
            return {
                isLoading: true,
                headers: [
                    {key: 'id', label: 'ID', sortable: true},
                    {key: 'title', label: 'Lote', sortable: true},
                    {key: 'images', label: 'Imágenes', sortable: true},
                    {key: 'video', label: 'Video', sortable: true},
                    {key: 'actions', label: 'Acciones', sortable: false},
                ]

            }
        },
        computed: {
            ...mapGetters({
                lots: 'lots/getEntries'
            })
        },
        created() {
            this.isLoading = true;
            this.$store.dispatch('lots/loadEntries').then(() => {
                this.isLoading = false;
            });
        }
    }
</script>